var _defs, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew334({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.78,8.29c0-.63-.07-1.38-.06-1.93h0c-.16.52-.34,1.08-.57,1.7l-.79,2.17H5.91L5.18,8.1C5,7.47,4.79,6.89,4.66,6.36h0c0,.55-.05,1.3-.09,2l-.12,1.91H3.89l.32-4.47h.73l.77,2.16c.18.55.33,1,.45,1.51h0c.11-.45.27-.94.47-1.51l.8-2.16h.73l.28,4.47H7.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.35,5.83a7.71,7.71,0,0,1,1.11-.08,1.81,1.81,0,0,1,1.25.37,1.19,1.19,0,0,1,.4.93,1.3,1.3,0,0,1-.35,1,1.82,1.82,0,0,1-1.37.49,2.13,2.13,0,0,1-.46,0v1.79H9.35ZM9.93,8a2.08,2.08,0,0,0,.48,0c.69,0,1.12-.34,1.12-1s-.42-.88-1.06-.88a2.16,2.16,0,0,0-.54,0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 2.75,
    y: 2.75,
    width: 10.5,
    height: 10.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew334);
export default __webpack_public_path__ + "static/media/Symbolpack_New_334.2bd6ebb6b02c74c6de1284c2786075ac.svg";
export { ForwardRef as ReactComponent };